import { EventStatus } from '../enums';
import { Event } from '../interfaces';
import { EvidenceAction } from '../interfaces/reviewActions';
import { useHasAccess } from './useHasAccess';

const printDownloadApprove = [EvidenceAction.Print, EvidenceAction.Download, EvidenceAction.JustApprove] as const;
const printAndDownload = [EvidenceAction.Print, EvidenceAction.Download] as const;

export const useEvidenceActions = (event?: Event) => {
  const hasAccess = useHasAccess();

  if (event?.status === EventStatus.approved) {
    return printAndDownload;
  }

  if (hasAccess && event) {
    return printDownloadApprove;
  }

  return printAndDownload;
};
